import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';
import {GreyButton} from 'components/Button';
import DealStatus from 'components/DealStatus';

import './style.css';

export default class Investment extends React.PureComponent {
  renderButton() {
    const {invite, deal, manage, interest, invest} = this.props;
    if (invite.type === 'lead') {
      return <GreyButton onClick={() => { manage({deal}); }} data-test="home_manage">Manage Deal</GreyButton>
    } else if (invite.type === 'investor') {
      if (deal.status === 'allocating') {
        return <GreyButton onClick={() => { interest({deal, invite}); }} data-test="home_interest">Invest</GreyButton>;
      } else if (deal.status === 'finalized' && !invite.allocation.documents.signed) {
        return <GreyButton onClick={() => { invest({allocation: invite.allocation}); }} data-test="home_invest">Sign Closing Docs</GreyButton>;
      } else {
        return ''
      }
    }
    return null;
  }
  render() {
    const {deal} = this.props;
    return (
      <Page>
        <h2>{deal.name}</h2>
        <img styleName="picture" src={deal.image} alt={deal.name} />
        <h3 styleName="status_header">Status</h3>
        <DealStatus status={deal.status} />
        <section styleName="button">{this.renderButton()}</section>
      </Page>
    )
  }
}

Investment.propTypes = {
  invite: PropTypes.shape({
    type: PropTypes.string.isRequired,
    self: PropTypes.string.isRequired,
    allocation: PropTypes.shape({
      self: PropTypes.string.isRequired,
      documents: PropTypes.shape({
        signed: PropTypes.bool.isRequired,
      }).isRequired,
    }),
  }).isRequired,
  deal: PropTypes.shape({
    self: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  manage: PropTypes.func.isRequired,
  interest: PropTypes.func.isRequired,
  invest: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./web/flows/home/components/Investment/component.js